import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getFormValues} from 'redux-form';
import * as modalActions from '../../actions/common/modalActions';
import SweetAlert from 'react-bootstrap-sweetalert'


class TemplateModal extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if(!this.props.isUpdate) {
            this.props.actions.enableTemplateAlertModal();
        }
        this.props.actions.disableTemplateAlertModal();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.showModal !== nextProps.showModal && nextProps.showModal) {
            this.props.actions.enableTemplateAlertModal();
            this.props.actions.showTemplateAlertModal('',
                'Uden billede vil din nyhed ikke blive vist i vores normale indholdsblokke med nyheder.');
        }
    }

    render() {

        return (
            <SweetAlert
                show={this.props.templateAlertModal.show}
                title={this.props.templateAlertModal.title}
                onConfirm={this.props.actions.hideTemplateAlertModal}
                confirmBtnCssClass="clickable"
            >
                {this.props.templateAlertModal.text}
            </SweetAlert>
        );
    }

}

function mapStateToProps(state, ownProps) {
    let form = getFormValues('article')(state);

    let showModal = form.templateId === 1;

    return {
        showModal: showModal,
        templateAlertModal: state.templateAlertModal
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ... modalActions
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TemplateModal);


// WEBPACK FOOTER //
// ./web/src/components/articles/TemplateModal.jsx